import React, { Fragment, useEffect, useState } from 'react';
import { Col, Form } from 'reactstrap';
import { CouponAmount, InvoiceTotalNo, key, key_secret } from '../../../../Constant';
import { useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Trash2 } from 'react-feather';
import { useSelector } from 'react-redux';
import { addClientPayment, addSetupCost, postCoupon } from '../../../../CommonUrl';
import { getMasterDataToken, postMasterToken } from '../../../../Utils/restUtils';
import { toast } from 'react-toastify';
import { PayPalButtons } from '@paypal/react-paypal-js';
import Paypal from '../Payapal/Paypal';

const schema = yup.object().shape({
    coupon: yup.string().required().label('Coupon'),
});

const OrderAmount = ({ datas, setLoading, details, companyId, features_list }) => {
    const navigate = useNavigate();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });
    const authState = useSelector((state) => state.auth);
    const [couponCode, setCouponCode] = useState('');
    const [couponList, setCouponList] = useState('');
    const [couponAmount, setCouponAmount] = useState(null);
    const [subTot, setSubTot] = useState(0);
    const [initialSubTot, setInitialSubTot] = useState(0);
    const [initialTotal, setInitialTotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [taxAmount, setTaxAmount] = useState([]);

    // Add payment method state, default to PayPal as per the design mockup
    const [paymentMethod, setPaymentMethod] = useState('paypal');
    const [paymentGateways, setPaymentGateways] = useState([]);

    useEffect(() => {
        paymentData();
        fetchGateways();
    }, [])

    const fetchGateways = async () => {
        try {
            const response = await getMasterDataToken("payment-gateways");
            if (response && response.status === true && Array.isArray(response.data)) {
                setPaymentGateways(response.data);
                if (response.data.length > 0) {
                    const hasPaypal = response.data.some(gw => gw.code === 'paypal');
                    setPaymentMethod(hasPaypal ? 'paypal' : response.data[0].code);
                }
            } else {
                setPaymentGateways([
                    { id: 1, name: "razorPay", code: "razorpay" },
                    { id: 2, name: "PayPal", code: "paypal" }
                ]);
                setPaymentMethod('paypal');
            }
        } catch (error) {
            console.error(error);
            setPaymentGateways([
                { id: 1, name: "razorPay", code: "razorpay" },
                { id: 2, name: "PayPal", code: "paypal" }
            ]);
            setPaymentMethod('paypal');
        }
    };

    const paymentData = () => {
        const list = datas.data.data[0];
        const subTotWithoutString = list.setup_cost;
        const calculatePercentage = list.taxRate.reduce((acc, e) => acc + (subTotWithoutString * e.tax_percentage / 100), 0);
        const totalValue = (subTotWithoutString + calculatePercentage).toFixed(2)
        setTotal(totalValue);
        setInitialTotal(totalValue);
        setCouponList(list);
        setSubTot(subTotWithoutString);
        setInitialSubTot(list.setup_cost);
    }

    const onSubmit = async (data) => {
        setLoading(true);
        const couponApi = await getMasterDataToken(postCoupon + `?coupon_code=${data.coupon}&package_id=${details.id}`);
        if (couponApi.status === true) {
            setCouponAmount(couponApi.data.discountAmount);
            setTotal(couponApi.data.invoiceTotal);
            setSubTot(couponApi.data.subTotal);
            setTaxAmount(couponApi.data.taxes);
            setCouponCode(data.coupon)
        }
        else {
            setLoading(false);
            toast.error(couponApi.message);
        }
        setLoading(false);
    };

    const handlePayment = async () => {
        setLoading(true);
        const result = await postMasterToken(addSetupCost, { package_id: details.id, coupon_code: couponCode, company_id: companyId });
        if (result.status === 200) {
            if (result.data.status === true) {
                const { id: orderId, email: email, name: name, mobile: mobile, amount: amount, currency: currency } = result.data.data;
                if (total === "") {
                    alert("please enter amount");
                } else {
                    var options = {
                        key: key,
                        key_secret: key_secret,
                        amount: amount.toString(),
                        currency: currency,
                        name: "BillerQ",
                        description: "for testing purpose",
                        order_id: orderId,
                        handler: async function (response) {
                            const data = {
                                orderCreationId: orderId,
                                razorpayPaymentId: response.razorpay_payment_id,
                                razorpayOrderId: response.razorpay_order_id,
                                razorpaySignature: response.razorpay_signature,
                            };
                            setLoading(true);
                            const payment = await postMasterToken(addClientPayment, data);
                            if (payment.status === 200) {
                                if (payment.data.status === true) {
                                    toast.success(payment.data.message);
                                    navigate('/billSuccess', { state: { payment_id: payment.data.data } });
                                } else {
                                    toast.error(payment.data.message);
                                    setLoading(false);
                                }
                            }
                        },
                        prefill: {
                            name: name,
                            email: email,
                            contact: mobile
                        },
                        notes: {
                            address: "Razorpay Corporate office"
                        },
                        theme: {
                            color: "#5F0F40" // Matching primary theme color
                        }
                    };
                    var pay = new window.Razorpay(options);
                    pay.open();
                }
            } else {
                toast.error(result.data.message);
                setLoading(false);
            }
        }
        setLoading(false);
    }

    const resetValues = () => {
        setCouponAmount(null);
        setSubTot(initialSubTot);
        setTotal(initialTotal);
        setTaxAmount([]);
        setValue("coupon", '');
        setCouponCode('');
    };

    const currencySymbol = features_list?.currency || 'USD';
    const planName = datas?.data?.data[0]?.name || 'Starter';

    return (
        <Col xl="6" lg="6" md="12" sm="12" className="ps-lg-4">
                <h4 className="payment-info-title">Payment Info</h4>
            <div className="payment-info-card">

                <div className="order-summary-box">
                    <div className="summary-item-header">
                        <span>{planName}</span>
                        <span>{currencySymbol} {datas?.data?.data[0]?.setup_cost}</span>
                    </div>

                    <div className="order-summary-section-label">ORDER SUMMARY</div>

                    <div className="summary-row">
                        <span>Setup Cost</span>
                        <span>{currencySymbol} {datas?.data?.data[0]?.setup_cost}</span>
                    </div>

                    {couponAmount != null && (
                        <div className="summary-row" style={{ color: '#16a34a', fontWeight: '600' }}>
                            <span>{CouponAmount}</span>
                            <span>- {currencySymbol} {couponAmount}</span>
                        </div>
                    )}

                    <div className="summary-row">
                        <span>Subtotal</span>
                        <span>{currencySymbol} {subTot}</span>
                    </div>

                    {taxAmount.length === 0 ? (
                        couponList && couponList.taxRate && couponList.taxRate.map((e) => {
                            const tAmt = (subTot * (e.tax_percentage / 100)).toFixed(2);
                            return (
                                <div key={e.id} className="summary-row">
                                    <span>{e.name} {e.tax_percentage}%</span>
                                    <span>{currencySymbol} {tAmt}</span>
                                </div>
                            );
                        })
                    ) : (
                        taxAmount.map((e, index) => (
                            <div key={index} className="summary-row">
                                <span>{e.name} {e.tax_percentage}%</span>
                                <span>{currencySymbol} {e.tax_amount}</span>
                            </div>
                        ))
                    )}

                    <div className="summary-row total">
                        <span>{InvoiceTotalNo}</span>
                        <span>{currencySymbol} {total}</span>
                    </div>

                    <div className="coupon-section">
                        {!couponCode ? (
                            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                                <div className="coupon-form-inline">
                                    <div className="coupon-input-wrapper">
                                        <input
                                            className="coupon-input-field"
                                            placeholder="Enter coupon code"
                                            id="coupon"
                                            type="text"
                                            {...register('coupon')}
                                        />
                                        {errors.coupon && (
                                            <span className="text-danger mt-1 d-block" style={{ fontSize: '11px' }}>
                                                {errors.coupon?.message}
                                            </span>
                                        )}
                                    </div>
                                    <button className="coupon-apply-btn" type="submit">
                                        Apply Coupon
                                    </button>
                                </div>
                            </Form>
                        ) : (
                            <div className="coupon-applied-badge">
                                <div className="coupon-applied-info">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    <span>Applied: <strong>{couponCode}</strong></span>
                                </div>
                                <button className="coupon-remove-btn" onClick={resetValues} type="button">
                                    <Trash2 size={16} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="payment-methods-title">Payment Method</div>

                <div className="payment-methods-group">
                    {paymentGateways.map((gateway) => {
                        const isSelected = paymentMethod === gateway.code;
                        return (
                            <div
                                key={gateway.id}
                                className={`payment-method-card ${isSelected ? 'selected' : ''}`}
                                onClick={() => setPaymentMethod(gateway.code)}
                            >
                                <div className="payment-method-left">
                                    <input
                                        type="radio"
                                        name="payment_method"
                                        className="payment-method-radio"
                                        checked={isSelected}
                                        onChange={() => setPaymentMethod(gateway.code)}
                                    />
                                    <span className="payment-method-label">
                                        {gateway.code === 'razorpay' ? 'razorPay' : gateway.name}
                                    </span>
                                </div>
                                <div className="payment-method-logo">
                                    {gateway.code === 'paypal' ? (
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M20.07 6.46C20.07 3.32 17.68 1 13.9 1H6.18C5.45 1 4.83 1.5 4.7 2.22L1.08 21.05C1 21.46 1.32 21.82 1.74 21.82H6.96C7.69 21.82 8.31 21.32 8.44 20.6L9.62 14.5L10 12.5C10.13 11.78 10.75 11.28 11.48 11.28H13.62C17.4 11.28 19.98 9.38 20.07 6.46Z" fill="#003087" />
                                            <path d="M16.92 9.46C16.92 6.32 14.53 4 10.75 4H3.03C2.3 4 1.68 4.5 1.55 5.22L0.08 14.73C-0.07 15.68 0.67 16.5 1.63 16.5H5.82L7 10.4L7.38 8.4C7.51 7.68 8.13 7.18 8.86 7.18H11C14.78 7.18 17.36 5.28 17.45 2.36C17.26 5.86 14.88 9.46 16.92 9.46Z" fill="#0079C1" />
                                        </svg>
                                    ) : gateway.code === 'razorpay' ? (
                                        <span style={{ fontWeight: '700', color: '#1e40af', fontSize: '13px' }}>Razorpay</span>
                                    ) : (
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="2" y="5" width="20" height="14" rx="2" ry="2" />
                                            <line x1="2" y1="10" x2="22" y2="10" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {paymentMethod === 'paypal' ? (
                    <div className="pay-now-btn-container">
                        {/* <PayPalButtons
                            style={{
                                layout: "vertical",
                                color: "blue",
                                shape: "rect",
                                label: "pay",
                                height: 48,
                            }}
                            createOrder={(data, actions) => {
                                return actions.order.create({
                                    purchase_units: [
                                        {
                                            amount: {
                                                value: total.toString(),
                                            },
                                        },
                                    ],
                                });
                            }}
                            onApprove={async (data, actions) => {
                                const details = await actions.order.capture();
                                toast.success(`Transaction completed by ${details.payer.name.given_name}`);
                                navigate('/billSuccess', { state: { payment_id: details.id } });
                            }}
                            onError={(err) => {
                                console.error(err);
                                toast.error("PayPal checkout error");
                            }}
                        /> */}
                        <Paypal setLoading={setLoading} cart={{
                            package_id: details.id,
                            company_id: companyId,
                            coupon_code: couponCode
                        }} />
                    </div>
                ) : (
                    <div className="pay-now-btn-container">
                        <button className="pay-now-primary-btn" onClick={handlePayment}>
                            Pay {currencySymbol} {total}
                        </button>
                    </div>
                )}

                <div className="secure-payment-footer">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                    <span>Payments are safe and secure</span>
                </div>
            </div>
        </Col>
    );
};

export default OrderAmount;